export const Resellerconstants = {
    RESELLER_REQUEST: 'RESELLER_LIST_REQUEST',
    RESELLER_SUCCESS: 'RESELLER_LIST_SUCCESS',
    RESELLER_FAILURE: 'RESELLER_LIST_FAILURE',

    INVOICE_REQUEST: 'AFFILIATE_INVOICE_REQUEST',
    INVOICE_SUCCESS: 'AFFILIATE_INVOICE_SUCCESS',
    INVOICE_FAILURE: 'AFFILIATE_INVOICE_FAILURE',
};
